
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const LandingHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  return (
    <header
      className={cn(
        "fixed top-0 z-50 w-full transition-all duration-300",
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      )}
    >
      <div className="container mx-auto flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex items-center">
          <Link to="/" className="text-xl font-semibold text-gray-900">
            <img src="/lovable-uploads/60f073cd-316e-4fa1-9add-c6553bdb9ac9.png" alt="Scaloo" className="h-8" />
          </Link>
        </div>

        <nav className="hidden space-x-8 md:flex">
          <a
            href="#features"
            className="text-sm font-medium text-gray-700 transition-colors hover:text-indigo-600"
          >
            Fonctionnalités
          </a>
          <a
            href="#benefits"
            className="text-sm font-medium text-gray-700 transition-colors hover:text-indigo-600"
          >
            Avantages
          </a>
          <a
            href="#pricing"
            className="text-sm font-medium text-gray-700 transition-colors hover:text-indigo-600"
          >
            Tarifs
          </a>
        </nav>

        <div className="flex items-center space-x-4">
          <Link to="/login" className="hidden sm:block">
            <Button
              variant="outline"
              className="h-10 rounded-md border-gray-300 text-gray-700 hover:bg-gray-50 hover:text-indigo-600"
            >
              Se connecter
            </Button>
          </Link>
          <Link to="/register">
            <Button className="h-10 rounded-md bg-indigo-600 text-white transition-all hover:bg-indigo-700">
              S'inscrire
            </Button>
          </Link>
          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-gray-700" />
            ) : (
              <Menu className="h-6 w-6 text-gray-700" />
            )}
          </button>
        </div>
      </div>
      
      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden">
          <div className="border-t border-gray-200 bg-white px-4 py-4">
            <nav className="flex flex-col space-y-4">
              <a
                href="#features"
                className="text-base font-medium text-gray-700 hover:text-indigo-600"
                onClick={() => setMobileMenuOpen(false)}
              >
                Fonctionnalités
              </a>
              <a
                href="#benefits"
                className="text-base font-medium text-gray-700 hover:text-indigo-600"
                onClick={() => setMobileMenuOpen(false)}
              >
                Avantages
              </a>
              <a
                href="#pricing"
                className="text-base font-medium text-gray-700 hover:text-indigo-600"
                onClick={() => setMobileMenuOpen(false)}
              >
                Tarifs
              </a>
              <Link
                to="/login"
                className="text-base font-medium text-gray-700 hover:text-indigo-600"
                onClick={() => setMobileMenuOpen(false)}
              >
                Se connecter
              </Link>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default LandingHeader;
